import { Trash01Icon } from '@langchain/untitled-ui-icons';
import { Button, Modal, ModalClose, ModalDialog } from '@mui/joy';

import { FC } from 'react';

import { cn } from '@/utils/tailwind';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  icon?: React.ReactNode;
  intent?: 'danger' | 'warning';
};

const DeleteConfirmationModal: FC<TProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  icon = <Trash01Icon className="h-6 w-6 text-error" />,
  intent = 'danger',
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalDialog
        style={{
          width: '500px',
        }}
      >
        <div className="flex flex-row items-start">
          <div
            className={cn(
              'rounded-full bg-error-secondary p-2',
              intent === 'warning' && 'bg-warning-secondary'
            )}
          >
            {icon}
          </div>
          <div className="ml-4 flex flex-col gap-2">
            <span className="text-lg font-bold">{title}</span>
            <span className="text-sm text-gray-500">{description}</span>
          </div>
          <div className="h-8 w-8">
            <ModalClose />
          </div>
        </div>
        <div className="ml-auto mt-4 flex flex-row gap-2">
          <Button
            type="button"
            data-testid="delete-confirmation-modal-cancel-button"
            size="sm"
            color="neutral"
            variant="outlined"
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button
            type="button"
            data-testid="delete-confirmation-modal-delete-button"
            size="sm"
            color={intent === 'danger' ? 'danger' : 'warning'}
            variant="solid"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </Button>
        </div>
      </ModalDialog>
    </Modal>
  );
};

export default DeleteConfirmationModal;
